'use client';

import dynamic from 'next/dynamic';
import type { FC, JSX } from 'react';
import type { ApiExcursion } from '../../../api/model';
import type { PartialPageProps } from '@/types/cms/magnolia';

const Excursions = dynamic(() => import('@/components/excursions/Excursions'));

const ExcursionsClientImporter: FC<{
  intro?: string;
  excursions?: Partial<ApiExcursion>[];
  theme?: string;
  pageProps?: PartialPageProps;
}> = (props): JSX.Element => {
  return <Excursions {...props} />;
};

export default ExcursionsClientImporter;
